import { render } from "./CadastroPlanilhaTrechos.vue?vue&type=template&id=3bf0dd84"
import script from "./CadastroPlanilhaTrechos.vue?vue&type=script&lang=ts"
export * from "./CadastroPlanilhaTrechos.vue?vue&type=script&lang=ts"
script.render = render

export default script